// import type { PopupRequest } from "@azure/msal-browser";
import { generateMsalConfig } from "@fdoh/api-client";
import type { IConfiguration } from "@fdoh/api-client";
// import type { IFlehsConfig } from "./types";

export const config: IConfiguration = {
  clientId: "357c1ea9-6f8a-4a43-8849-e419dea39c5f",
  title: "FLEHS",
  version: "0.0.1-alpha-1",
  applications: [
    {
      name: "graphApi",
      apiType: "graph",
      baseUrl: "https://graph.microsoft.com/v1.0",
      scopes: [
        // "openid",
        "offline_access",
        "email",
        "profile",
        "https://graph.microsoft.com/User.ReadBasic.All",
        "https://graph.microsoft.com/People.Read",
      ],
    },
    {
      name: "flehsApi",
      apiType: "custom",
      baseUrl: "https://localhost:5001",
      scopes: ["api://5b9d1c95-aa2d-4545-af3f-72cc38b875f4/Flehs.User"],
    },
  ],

  authority:
    "https://login.microsoftonline.com/28cd8f80-3c44-4b27-81a0-cd2b03a31b8d",
  redirectUri: "/",
  postLogoutRedirectUri: "/",
  cacheLocation: "localStorage",
};

export const msalConfig = generateMsalConfig(config);

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const getConfig = (): IConfiguration => {
  config.title = import.meta.env.VITE_APPSETTINGS_TITLE ?? "";
  config.version = __APP_VERSION__ ?? "";

  config.applications[1].baseUrl =
    import.meta.env.VITE_APPSETTINGS_API_URL ?? "";
  return config;
};
